import { Button, Col, DatePicker, Form, Modal, Row, Select } from 'antd';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getAssociates, getBoxWorkType, getSelectBoxWorkStatusActivities } from 'app/entities/common/common.reducer';
import { getEntities as getEmployees } from 'app/entities/employee/employee.reducer';
import { getEntities as getFields } from 'app/entities/field/field.reducer';
import { setFilterActivities } from 'app/entities/filters/filters.reducer';
import { getEntities as getProjects } from 'app/entities/project/project.reducer';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import './style.scss';
const { RangePicker } = DatePicker;

type IFilterProps = {
  visible: boolean;
  onCancel: () => void;
};


const FilterModal = ({ visible, onCancel }: IFilterProps) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const projectList = useAppSelector(state => state.project.entities);
  const employeeList = useAppSelector(state => state.employee.entities);
  const fieldList = useAppSelector(state => state.field.entities);
  const workTypeList = useAppSelector(state => state.common.workType);
  const workStatusList = useAppSelector(state => state.common.workStatusActivities);
  const associateList = useAppSelector(state => state.common.associates);
  const filters = useAppSelector(state => state.filters.activities);

  useEffect(() => {
    innitData();
  }, []);

  useEffect(() => {
    if (filters) {
      if (filters.fromDate && filters.toDate) {
        form.setFieldValue('dateRanges', [dayjs(filters.fromDate), dayjs(filters.toDate)]);
      }
      form.setFieldsValue(filters);
    }
  }, [filters]);

  const innitData = () => {
    dispatch(getSelectBoxWorkStatusActivities());
    dispatch(getBoxWorkType());
    dispatch(getAssociates());
    dispatch(getFields({}));
    dispatch(getEmployees({}));
    dispatch(getProjects({}));
  };

  const handleFilter = () => {
    form.validateFields().then(values => {
      // Destructure the dateRanges field
      const { dateRanges } = values;

      // Initialize startDate and endDate
      let fromDate, toDate;

      if (dateRanges && dateRanges.length >= 1) {
        fromDate = dateRanges[0] && dateRanges[0].format(APP_LOCAL_DATE_FORMAT_PAYLOAD);
        toDate = dateRanges[1] && dateRanges[1].format(APP_LOCAL_DATE_FORMAT_PAYLOAD);
      }

      // Prepare the final form values
      const finalValues = {
        ...filters,
        ...values,
        startDate: fromDate,
        dueDate: toDate,
      };
      dispatch(setFilterActivities(finalValues));
      handleClose();
    });
  };

  const handleClose = () => {
    onCancel();
  };

  const handleReset = () => {
    form.resetFields();
    handleFilter();
  };

  return (
    <Modal
      width={500}
      className="modal-filter-custom"
      open={visible}
      maskClosable={false}
      footer={null}
      title="Bộ lọc tìm kiếm"
      onCancel={handleClose}
    >
      <Form size="large" form={form} onFinish={handleFilter} layout="vertical">
        <Row>
          <Col md={11}>
            <Form.Item label="KR liên quan" name="objectiveParentId">
              <Select
                mode="multiple"
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={associateList}
                placeholder="Chọn mục tiêu, Kr liên kết"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Thực hiện chính (PIC)" name="pic">
              <Select
                mode="multiple"
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={employeeList.map(x => {
                  return {
                    label: x.name,
                    value: x.id,
                  };
                })}
                placeholder="Chọn người thực hiện chính"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Trạng thái công việc" name="workStatus">
              <Select
                mode="multiple"
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn trạng thái"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Lĩnh vực" name="field">
              <Select
                mode="multiple"
                allowClear
                showSearch
                size="large"
                filterOption={filterOption}
                options={fieldList.map(x => {
                  return {
                    label: x.description,
                    value: x.value,
                  };
                })}
                placeholder="Chọn lĩnh vực"
              />
            </Form.Item>
          </Col>

        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Dự án" name="projectId">
              <Select
                mode="multiple"
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={projectList.map(x => {
                  return {
                    label: x.name,
                    value: x.id,
                  };
                })}
                placeholder="Chọn dự án"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Mảng công việc" name="workTypeId">
              <Select
                mode="multiple"
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workTypeList.map(x => {
                  return {
                    ...x,
                    label: x.name,
                    value: x.id,
                  };
                })}
                placeholder="Chọn mảng công việc"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col md={24}>
            <Form.Item label="Thời gian thực hiện" name="dateRanges">
              <RangePicker format={APP_LOCAL_DATE_FORMAT} placeholder={['Ngày bắt đầu', 'Thời hạn hoàn thành']} className='w-100' size='large' />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Row className="action mt-3" justify="end">
            <Col>
              <Button
                onClick={() => {
                  handleReset();
                }}
                className="secondary"
                size="large"
              >
                Bỏ lọc
              </Button>
            </Col>
            <Col>
              <Button size="large" className="primary" htmlType="submit">
                Tìm kiếm
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FilterModal;
